"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedNumber = _interopRequireDefault(require("./FormattedNumber"));

var _NumberTypes = _interopRequireDefault(require("../constants/NumberTypes"));

var _default = _react.default.createClass({
  displayName: "FormattedPercentage",
  propTypes: {
    precision: _react.PropTypes.number,
    stripInsignificantZeros: _react.PropTypes.bool,
    value: _react.PropTypes.number.isRequired
  },
  render: function render() {
    return _react.default.createElement(_FormattedNumber.default, (0, _extends2.default)({
      style: _NumberTypes.default.PERCENTAGE
    }, this.props));
  }
});

exports.default = _default;
module.exports = exports.default;